import { getCurrentUser, getAuthHeader, API_BASE_URL } from './base';

export const createWorkspace = async (name = "") => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");
    const response = await fetch(`${API_BASE_URL}/api/workspaces`, {
      method: "POST",
      headers: {
        ...(await getAuthHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name }), // Pass the name as payload
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const workspace = await response.json();
    return workspace;
  } catch (error) {
    console.error("Failed to create workspace:", error);
    throw error;
  }
};
export const editWorkspace = async (name = "", id) => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");
    const response = await fetch(`${API_BASE_URL}/api/workspaces/${id}`, {
      method: "PUT",
      headers: {
        ...(await getAuthHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, workspaceId: id }), // Pass the name as payload
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const workspace = await response.json();
    return workspace;
  } catch (error) {
    console.error("Failed to create workspace:", error);
    throw error;
  }
};

export const moveSurvey = async (workspaceId, surveyId, sourceWorkspaceId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/workspaces/${workspaceId}/moveSurvey`,
      {
        method: "POST",
        headers: {
          ...(await getAuthHeader()),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ surveyId, sourceWorkspaceId }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Move survey response error:", {
        status: response.status,
        text: errorText,
      });
      throw new Error(`Failed to move survey: ${response.status}`);
    }

    return await response.json(); // Return the updated workspace data
  } catch (error) {
    console.error("Error moving survey:", error);
    throw error;
  }
};

export const deleteWorkspace = async (workspaceId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/workspaces/${workspaceId}`,
      {
        method: "DELETE",
        headers: {
          ...(await getAuthHeader()),
          "Content-Type": "application/json",
        }, // Pass the surveyId in the request body
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("delet workspace response error:", {
        status: response.status,
        text: errorText,
      });
      throw new Error(`Failed to delete workspace: ${response.status}`);
    }

    return await response.json(); // Return the updated workspace data
  } catch (error) {
    console.error("Error while delete workspace:", error);
    throw error;
  }
};
